import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const DescripcionesPuestos = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Descripciones de Puestos</h1>
        </div>
        <div className="orgproc-grid">
          <div className="orgproc-card">
            <div className="orgproc-card-accent"></div>
            <div className="orgproc-card-body">
              <div className="orgproc-eyebrow">Proceso #1</div>
              <div className="orgproc-card-title">Puesto: PM</div>
              <p className="orgproc-card-desc">Descripción</p>
              <Link className="orgproc-card-btn" to="/descripciones-puestos/puesto-pm">
                Procedimiento →
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default DescripcionesPuestos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
